'use strict';
import React from 'react';
import FactoryCellInterface from './FactoryCellInterface';
import { RealtyType, PriceTotal, PricePerMeter, Area, MoreProperty, Date,
  Contacts, Floor, Address, Photos, Material, Seller, BuildingSize, DealCondition } from '../PaperCells';

class FactoryPaperCell extends FactoryCellInterface {
  makeRealtyType (key, data) {
    return <RealtyType key={key} item={data} user={this.user} domain={this.domain} />;
  }

  makePriceTotal (key, data) {
    return <PriceTotal key={key} item={data} />;
  }

  makePricePerMeter (key, data) {
    return <PricePerMeter key={key} item={data} />;
  }

  makeArea (key, data) {
    return <Area key={key} item={data} />;
  }

  makeContacts (key, data, onUpdateFilter, eventShowContacts, rawData) {
    return <Contacts
      key={key} item={data}
      rawItem={rawData}
      user={this.user}
      onUpdateFilter={onUpdateFilter}
      eventShowContacts={eventShowContacts}
    />;
  }

  makeMoreProperty (key, data) {
    return <MoreProperty key={key} item={data} />;
  }

  makeDate (key, data) {
    return <Date key={key} item={data} />;
  }

  makeAddress (key, data, eventClickAnnouncement, rawData) {
    return <Address key={key} item={data} eventClickAnnouncement={eventClickAnnouncement} rawItem={rawData} />;
  }

  makePhotos (key, data, eventClickAnnouncement, rawData) {
    return <Photos key={key} item={data} eventClickAnnouncement={eventClickAnnouncement} rawItem={rawData} />;
  }

  makeMaterial (key, data) {
    return <Material key={key} item={data} />;
  }

  makeSeller (key, data, onUpdateFilter) {
    return <Seller key={key} item={data} onUpdateFilter={onUpdateFilter} />;
  }

  makeFloor (key, data) {
    return <Floor key={key} item={data} />;
  }

  makeBuildingSize (key, data) {
    return <BuildingSize key={key} item={data} />;
  }

  makeDealCondition (key, data) {
    return <DealCondition key={key} item={data} />;
  }
}

export default FactoryPaperCell;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/Factory/FactoryPaperCell.jsx